import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import '../../styles/Admin.css';

interface Role {
  __enumName__: string;
  _code: string;
  _name: string;
}

interface User {
  id: string;
  username: string;
  isActive: boolean;
  role: Role;
  school: string;
  createdAt: string;
}

interface UserListProps {
  onEditUser: (user: User) => void;
  onDeleteUser: (userId: string) => void;
}

const UserList: React.FC<UserListProps> = ({ onEditUser, onDeleteUser }) => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get('/users');
      setUsers(response.data.result);
      setLoading(false);
    } catch (err) {
      setError('사용자 목록을 불러오는데 실패했습니다.');
      setLoading(false);
    }
  };

  const getRoleLabel = (role: Role) => {
    const roleMap: { [key: string]: { label: string; className: string } } = {
      'ADMIN': { label: '관리자', className: 'badge-role-admin' },
      'PROFESSOR': { label: '교수', className: 'badge-role-professor' },
      'STUDENT': { label: '학생', className: 'badge-role-student' }
    };
    return roleMap[role._code] || { label: role._name, className: 'badge-neutral' };
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-message">
        <span>⚠️</span>
        {error}
      </div>
    );
  }

  return (
    <div className="admin-card-body">
      <table className="user-table">
        <thead>
          <tr>
            <th>사용자명</th>
            <th>역할</th>
            <th>학교</th>
            <th>상태</th>
            <th>가입일</th>
            <th>작업</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const roleInfo = getRoleLabel(user.role);
            return (
              <tr key={user.id}>
                <td>{user.username}</td>
                <td>
                  <span className={`badge ${roleInfo.className}`}>
                    {roleInfo.label}
                  </span>
                </td>
                <td>{user.school || '-'}</td>
                <td>
                  <span className={`badge ${user.isActive ? 'badge-success' : 'badge-neutral'}`}>
                    {user.isActive ? '활성' : '비활성'}
                  </span>
                </td>
                <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                <td>
                  <button
                    onClick={() => onEditUser(user)}
                    className="btn btn-secondary btn-sm"
                  >
                    수정
                  </button>
                  <button
                    onClick={() => onDeleteUser(user.id)}
                    className="btn btn-secondary btn-sm"
                  >
                    삭제
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UserList;
